module.exports = __webpack_public_path__ + "img/contactImg.8388e84a.svg";